"use client";
// LEGACY UI: replace with Button from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).
import classNames from "@casino/external/classNames";
import MoonButton from "@casino/legacyUi/Button";
import type { ComponentProps, HTMLProps } from "react";

type Props = Omit<HTMLProps<HTMLButtonElement>, "size"> &
  ComponentProps<typeof MoonButton> & {
    className?: string;
    as?: React.ElementType;
    site: string;
  };

const Button: FC<Props> = ({
  children,
  className,
  variant = "primary",
  site,
  ...props
}) => {
  const sites = ["bitcasino", "sportsbet"];
  return (
    <MoonButton
      data-testid="tw-button"
      className={classNames(
        sites.includes(site) && variant === "tertiary" && "text-foreground",
        className,
      )}
      variant={variant}
      {...props}
    >
      {children}
    </MoonButton>
  );
};

export default Button;
